import {
  Component,
  EventEmitter,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { NgClass } from '@angular/common';

type UpgradeRole = 'schuleinheit' | 'schulgemeinde';

type RoleCard = {
  id: UpgradeRole;
  iconSrc: string;
  iconClass: string;
  title: string;
  badge?: string;
  description: string;
};

@Component({
  selector: 'app-upgrade-role-selector',
  templateUrl: './upgrade-role-selector.component.html',
  styleUrls: ['./upgrade-role-selector.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass],
})
export class UpgradeRoleSelectorComponent {
  @Output() roleSelected = new EventEmitter<UpgradeRole>();

  roles: RoleCard[] = [
    {
      id: 'schuleinheit',
      iconSrc: '/assets/onboarding/welcome-school.svg',
      iconClass: 'welcome-role-card__icon--schuleinheit',
      title: 'Schuleinheit',
      badge: 'Kostenlos starten',
      description:
        'Dein Schulprofil ganzjährig sichtbar machen und unbegrenzt Feststellen und Stellvertretungen schalten. Bewerbungen zentral verwalten und Zeit für den Alltag gewinnen.',
    },
    {
      id: 'schulgemeinde',
      iconSrc: '/assets/onboarding/welcome-community.svg',
      iconClass: 'welcome-role-card__icon--schulgemeinde',
      title: 'Schulgemeinde',
      description:
        'Bestes Preis-Leistungsverhältnis: Arbeitgeber-Sichtbarkeit für Schulgemeinde und Schuleinheiten, inkl. unbegrenzter Feststellen und Stellvertretungen auf beiden Ebenen.',
    },
  ];

  select(role: UpgradeRole) {
    this.roleSelected.emit(role);
  }
}
